"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CuratedForYouHero() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222869" id="timeless-moments-captured" className="relative w-full bg-background text-foreground overflow-hidden py-24 lg:py-32 xl:py-40">
      {}
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 flex flex-col gap-8 z-10 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] xl:text-[6.5rem] font-light font-default leading-[1.05] tracking-tight text-foreground">
              Capturing Love, <br className="hidden md:block" />
              <span className="text-foreground/70 italic">Beautifully Framed.</span>
            </h1>
            
            <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed font-light">
              Capturing the essence of your love through a soft-toned, cinematic lens. Ivory Lens specializes in modern wedding photography that preserves your most cherished memories with elegance and grace.
            </p>
            
            <div className="flex items-center gap-4 pt-4">
              <Link to="/CollectionsPage">
                <Button size="lg" className="h-14 px-8 text-base rounded-md shadow-md bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-0.5 transition-all duration-500">
                  Explore the Gallery
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 relative z-0 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <div className="relative w-full max-w-md mx-auto lg:ml-auto aspect-[4/5] lg:aspect-[3/4]">
              
              {}
              <div className="absolute inset-0 bg-secondary rounded-lg transform rotate-2 scale-105 transition-transform duration-1000 hover:rotate-3 shadow-sm"></div>
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_couple_natural_light.png" alt="Timeless Wedding Moments" className="absolute inset-0 w-full h-full object-cover rounded-md shadow-xl shadow-foreground/5 z-10 transition-transform duration-1000 hover:scale-[1.02]" />
              
              {}
              <div className="absolute -bottom-8 -left-8 w-44 aspect-square z-20">
                <div className="relative w-full h-full">
                  <div className="absolute inset-0 bg-accent/30 rounded-md blur-xl transform translate-y-4"></div>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/bridal_detail_soft_focus.png" alt="Elegant Detail" className="relative w-full h-full object-cover rounded-md shadow-lg border border-border/30 transition-transform duration-700 hover:-translate-y-2" />
                </div>
              </div>

              {}
              <div className="absolute top-12 -right-6 z-30 bg-background/60 backdrop-blur-md px-6 py-4 rounded-md shadow-md border border-border/20 animate-pulse" style={{
              animationDuration: '6s'
            }}>
                <div className="flex items-center gap-3">
                  <div className="size-1.5 rounded-lg bg-primary/40 animate-ping"></div>
                  <p className="font-default text-sm font-medium tracking-wide text-foreground/80">Fine Art Collection</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}